export enum LogType {
    DocumentAdd = 'document-add',
    DocumentEdit = 'document-edit',
    DocumentStatus = 'document-status',
    DocumentDelete = 'document-delete',
    UserAdd = 'user-add',
    UserEdit = 'user-edit',
    UserDelete = 'user-delete',
    SettingsEdit = 'settings-edit'
}